/* eslint-disable no-console */
import { useEffect } from 'react';
import { detectBrowserCompatibility, redirectToOldPortal } from 'shared/utils/browserCompat';

/**
 * BrowserDetector Component
 *
 * Runs comprehensive browser compatibility detection after React mounts.
 * This acts as a second layer of defense after the HTML-level detection.
 *
 * - Detects JavaScript and CSS feature support
 * - Identifies known problematic browsers
 * - Auto-redirects to old portal if incompatible
 * - Logs warnings for partially compatible browsers
 */
export function BrowserDetector() {
    useEffect(() => {
        const result = detectBrowserCompatibility();

        if (result.recommendation === 'redirect') {
            console.warn(
                'Incompatible browser detected:',
                {
                    failedFeatures: result.failedFeatures,
                    userAgent: result.userAgent,
                    compatibilityScore: result.compatibilityScore
                }
            );

            redirectToOldPortal('react-mount');
        } else if (result.recommendation === 'warn') {
            console.warn(
                'Browser partially compatible:',
                {
                    failedFeatures: result.failedFeatures,
                    compatibilityScore: result.compatibilityScore
                }
            );
        }
    }, []);

    return null;
}
